import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./App.css";

const RSS_FEED_URL = "https://anchor.fm/s/2e40168/podcast/rss";

function EpisodesPage() {
    const [episodes, setEpisodes] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchRSSFeed = async () => {
            try {
                const response = await fetch(RSS_FEED_URL);
                const text = await response.text();

                // Parse XML
                const parser = new DOMParser();
                const xml = parser.parseFromString(text, "application/xml");
                const items = xml.querySelectorAll("item");

                // Extract all episodes
                const allEpisodes = Array.from(items).map((item) => ({
                    title: item
                        .querySelector("title")
                        .textContent.replace("<![CDATA[", "")
                        .replace("]]>", ""),
                    image:
                        item
                            .querySelector("itunes\\:image, image")
                            ?.getAttribute("href") ||
                        "https://via.placeholder.com/300x200",
                    description:
                        item.querySelector("itunes\\:summary, description")
                            ?.textContent || "No description available",
                    pubDate: new Date(
                        item.querySelector("pubDate").textContent
                    ).toDateString(),
                    audio:
                        item.querySelector("enclosure")?.getAttribute("url") ||
                        "",
                }));

                setEpisodes(allEpisodes);
            } catch (error) {
                console.error("Error fetching RSS feed:", error);
            }
        };

        fetchRSSFeed();
    }, []);

    return (
        <div className="episodes-page">
            <header>
                <div className="container">
                    <Link to="/" className="btn back-btn">
                        ← Back to Home
                    </Link>
                    <h1>All Episodes</h1>
                </div>
            </header>

            <section className="container">
                <div className="episode-grid">
                    {episodes.length > 0 ? (
                        episodes.map((episode, index) => (
                            <div className="episode" key={index}>
                                <img src={episode.image} alt={episode.title} />
                                <h3>{episode.title}</h3>
                                <p>{episode.description}</p>
                                <p className="pub-date">
                                    Published: {episode.pubDate}
                                </p>
                                <button
                                    className="btn"
                                    onClick={() =>
                                        navigate(`/episode/${index}`, {
                                            state: { episode },
                                        })
                                    }
                                >
                                    Listen
                                </button>
                            </div>
                        ))
                    ) : (
                        <p>Loading episodes...</p>
                    )}
                </div>
            </section>
        </div>
    );
}

export default EpisodesPage;
